import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { FormBuilder, FormGroup, ValidatorFn, Validators, AbstractControl } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-view-rate-details',
  templateUrl: './view-rate-details.component.html',
  styleUrls: ['./view-rate-details.component.scss']
})
export class ViewRateDetailsComponent implements ICellRendererAngularComp {
  submissionStatus: boolean | null = null;
  rate_uuid: string | null = null;
  gridType = '';
  new_rate_form: FormGroup = this.fb.group(
  {
    new_rate: [0.0, Validators.required],
    start_date: [new Date(), Validators.required],
    end_date: [new Date(), Validators.required],
    min_rate: [0.0]
  },
  { validator: startDateBeforeEndDateValidator()}
  ) 

  constructor(private fb: FormBuilder, private http: HttpClient){
    this.checkRequired();
  }

  agInit(params: any){
    if(params.data.tmp_zone_rate_uuid){
      this.rate_uuid = params.data.tmp_zone_rate_uuid;
    }
    else if(params.data.rate_uuid){
      this.rate_uuid = params.data.rate_uuid;
    }
    else if(params.data.carrier_zone_rate_uuid){
      this.rate_uuid = params.data.carrier_zone_rate_uuid;
    }

    this.gridType = params.detailGridId;
  }

  refresh(params: any): boolean{
    return false;
  }

  // Depending on the grid type, set required validator for minimum rate
  checkRequired(){
    const control = this.new_rate_form.get('min_rate');
    if(this.gridType === 'customer-rates'){
      control?.setValidators([Validators.required]);
    }
    control?.updateValueAndValidity();
  }

  submitNewRate(){
    // send grid type and form values
    if(this.new_rate_form.valid){
      let postData = {
        rate_type: this.gridType.substring(0, this.gridType.indexOf('-')),
        rate: this.new_rate_form.get('new_rate')?.value,
        start_date: this.new_rate_form.get('start_date')?.value,
        end_date: this.new_rate_form.get('end_date')?.value,
        min_rate: this.new_rate_form.get('min_rate')?.value,
        rate_uuid: this.rate_uuid
      }
      console.log(postData);
      const headers = new HttpHeaders({ 'Content-Type': 'application/json'});
      this.http.post<any>('/api/rates/view_rates.php', postData, { headers }).subscribe(
        (response) => {
          console.log(JSON.stringify(response));
          this.submissionStatus = true;
          this.clearForm();
        },
        (error) => {
          console.error('Error submitting: ', JSON.stringify(error));
          this.submissionStatus = false;
        }
      )
    }
    else{
      console.log('Form is invalid');
      this.new_rate_form.markAllAsTouched();
    }
  }

  clearForm(){
    this.new_rate_form.reset();
  }
}

export function startDateBeforeEndDateValidator(): ValidatorFn {
  return (formGroup: AbstractControl): { [key: string]: any} | null => {
    const startDate = formGroup.get('start_date')?.value;
    const endDate = formGroup.get('end_date')?.value;
    if (new Date(startDate) > new Date(endDate)){
      return { startDateAfterEndDate: true};
    }
    return null;
  }
}